<template>
	<div class="delivery-body">
		<div class="fx-title">
			<p>订单信息</p>
		</div>
		<div class="delivery-info" v-if="afterSaleId">
			<p>订单状态：{{detailInfo.orderStatus === 3 ? '待收货' : detailInfo.orderStatus === 4 ? '已完成' : ''}}</p>
			<p>下单时间：{{detailInfo.createDate}}</p>
			<p>备货时间：{{detailInfo.prepareDate}}</p>
			<p>期望到货时间：{{detailInfo.wantArrivalDate}}</p>
			<p>收货人：{{detailInfo.buyerName}}</p>
			<p>收货地址：{{detailInfo.ob_address}}</p>
			<p>联系方式：{{detailInfo.buyerTel}}</p>
		</div>
		<div class="delivery-info" v-else>
			<div class="empty-info">
				<img src="~/images/icon/empty-info.png" alt="">
				<p style="padding: 17px 0 9px 0;">暂无数据</p>
			</div>
		</div>
		<div class="flow-order">
			<div class="fx-title">
				<p>售后单跟踪</p>
			</div>
			<div class="block" v-if="detailData.length > 0">
				<el-timeline>
					<el-timeline-item
						v-for="item in detailData"
						:key="item.time"
						placement="top"
					>
						<div class="timeline">
							<div style="display: flex;flex-flow: row;align-items: center;">
								<h5 v-if="item.type === 0">创建时间</h5>
								<h5 v-if="item.type === 1">新增商品</h5>
								<h5 v-if="item.type === 2">编辑商品</h5>
								<h5 v-if="item.type === 3">删除商品</h5>
								<h5 style="padding-left:10px;">{{item.createDate}}</h5>
							</div>
							<!-- <h5 style="padding-top: 15px;color: #f95151;font-weight:bold;">{{item.reason}}</h5> -->
						</div>
						<p class="operator">操作人：{{item.username}}</p>
					</el-timeline-item>
				</el-timeline>
			</div>
			<div class="delivery-info" style="border-bottom:0;margin-top:100px" v-if="detailData.length === 0">
				<div class="empty-info">
					<img src="~/images/icon/empty-info.png" alt="">
					<p style="padding: 17px 0 9px 0;">暂无数据</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'deliveryInfo',
	props: {
		detailData: {
			type: Array
		},
		detailInfo: {
			type: Object
		},
		afterSaleId: {
			type: String
		}
	},
	data () {
		return {
			orderId: '',
			deliveryWay: '',
			deliveryCompany: '',
			deliveryCode: '',
			dialogVisible: false,
			ffm_orderbatchid: 1,
			// backorderdock: 1,
			// clddock: 0,
			options: [
				{ 'id': 'shunfeng', 'value': '顺丰' },
				{ 'id': 'yuantong', 'value': '圆通' },
				{ 'id': 'yunda', 'value': '韵达' },
				{ 'id': 'shentong', 'value': '申通' },
				{ 'id': 'huitongkuaidi', 'value': '百世' },
				{ 'id': 'zhongtong', 'value': '中通' },
				{ 'id': 'ems', 'value': 'EMS' },
				{ 'id': 'debangwuliu', 'value': '德邦' },
				{ 'id': 'debangkuaidi', 'value': '德邦快递' },
				{ 'id': 'youzhengbk', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong', 'value': '宅急送' },
				{ 'id': '0', 'value': '其他' }
			],
			value: '',
			code: '',
			orderStatus: '',
			expressId: '',
			orderfollowArr: [],
			orderType0: [
				{ status: 0, name: '下单时间' },
				{ status: 1, name: '付款时间' },
				{ status: 2, name: '接单时间' },
				{ status: 3, name: '发货时间' },
				{ status: 4, name: '收货时间' }
			],
			orderType1: [
				{ status: 0, name: '接单时间' },
				{ status: 1, name: '下单时间' },
				{ status: 2, name: '付款时间' },
				{ status: 3, name: '发货时间' },
				{ status: 4, name: '收货时间' }
			],
			orderType2_status1: [
				{ cause: 0, name: '申请取消时间', reason: '买家申请取消：商家无货' },
				{ cause: 1, name: '申请取消时间', reason: '买家申请取消：操作有误(地址选错,商品选错)' },
				{ cause: 2, name: '申请取消时间', reason: '买家申请取消：重复下单' },
				{ cause: 3, name: '申请取消时间', reason: '买家申请取消：价格有变' },
				{ cause: 4, name: '申请取消时间', reason: '买家申请取消：不想买了' },
				{ cause: 5, name: '申请取消时间', reason: '买家申请取消：其他原因' }
			],
			orderType2_status1_7: [
				{ cause: 7, name: '拒单时间', reason: '库存不足' },
				{ cause: 8, name: '拒单时间', reason: '未达起送标准' },
				{ cause: 9, name: '拒单时间', reason: '商品停售' },
				{ cause: 10, name: '拒单时间', reason: '其他原因' }
			],
			orderType2_status2: [
				{ cause: 0, name: '同意取消时间', reason: '买家申请取消：商家无货' },
				{ cause: 1, name: '同意取消时间', reason: '买家申请取消：操作有误(地址选错,商品选错)' },
				{ cause: 2, name: '同意取消时间', reason: '买家申请取消：重复下单' },
				{ cause: 3, name: '同意取消时间', reason: '买家申请取消：价格有变' },
				{ cause: 4, name: '同意取消时间', reason: '买家申请取消：不想买了' },
				{ cause: 5, name: '同意取消时间', reason: '买家申请取消：其他原因' }
			],
			orderType2_status3: [
				{ cause: 0, name: '拒绝取消时间', reason: '卖家拒绝取消：商品已经出库' },
				{ cause: 1, name: '拒绝取消时间', reason: '卖家拒绝取消：商品开始生产' },
				{ cause: 2, name: '拒绝取消时间', reason: '卖家拒绝取消：取消理由不合理' },
				{ cause: 3, name: '拒绝取消时间', reason: '卖家拒绝取消：申请已超时' },
				{ cause: 4, name: '拒绝取消时间', reason: '卖家拒绝取消：其他原因' }
			],
			recordList: [],
			moreRecordList: [],
			showMoreInfo: false,
			needauditingflag: false
		}
	},
	watch: {
	},
	methods: {
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		findSendInfoOfHistory () {
			let params = {
				orderId: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId,
				sendtype: -1,
				filterType: 0,
				oiid: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findSendInfoOfHistoryNew`,
				data: params
			}).then(res => {
				this.recordList = res.recordList.concat()
				this.moreRecordList = res.recordList.concat()
				if (this.recordList.length > 3) {
					this.showMoreInfo = true
					this.recordList.length = 3
				} else {
					this.showMoreInfo = false
				}
			})
		},
		searchMoreInfo () {
			window.sessionStorage.setItem('historyoiid', 0)
			this.$router.push('/main/deliverHistory')
		},
		goDeliverHistory (item) {
			window.sessionStorage.setItem('historyoiid', 0)
			window.sessionStorage.setItem('createdate', item.senddate)
			this.$router.push('/main/deliverHistory')
		},
		orderfollow () {
			this.orderfollowArr = []
			let params = {
				orderid: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/orderfollow/get`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						this.needauditingflag = item.needauditingflag
						switch (item.orderType) {
						case 2:
							if (item.status === 0) {
								this.orderfollowArr.unshift({
									name: '取消时间',
									reason: '订单超时取消',
									time: item.modifydate,
									username: item.username
								})
							} else if (item.status === 1) {
								if (item.cause < 7) {
									this.orderfollowArr.unshift({
										name: this.orderType2_status1[item.cause].name,
										reason: this.orderType2_status1[item.cause].reason,
										time: item.modifydate,
										username: item.username
									})
								} else {
									this.orderfollowArr.unshift({
										name: this.orderType2_status1_7[item.cause - 7].name,
										reason: item.cause === 10 ? (item.othercause === '' ? this.orderType2_status1_7[item.cause - 7].reason : item.othercause) : this.orderType2_status1_7[item.cause - 7].reason,
										time: item.modifydate,
										username: item.username
									})
								}
							} else if (item.status === 2) {
								this.orderfollowArr.unshift({
									name: this.orderType2_status2[item.cause].name,
									// reason: this.orderType2_status2[item.cause].reason,
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else if (item.status === 3) {
								this.orderfollowArr.unshift({
									name: this.orderType2_status3[item.cause].name,
									reason: item.cause === 4 ? (item.othercause === '' ? this.orderType2_status3[item.cause].reason : item.othercause) : this.orderType2_status3[item.cause].reason,
									time: item.modifydate,
									username: item.username
								})
							}
							break
						case 0:
							if (item.status === 3 && item.buyerpullstate === 1) {
								this.orderfollowArr.unshift({
									name: '买家供应链接收时间',
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else if (item.status === 4 && item.buyerpullstate === 1) {
								this.orderfollowArr.unshift({
									name: '买家供应链入库时间',
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else if (item.status === 2 && item.sellerpullstate === 1) {
								this.orderfollowArr.unshift({
									name: '备货中时间',
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else if ((item.cause === 1) && (item.status === 3 || item.status === 4)) {
								this.orderfollowArr.unshift({
									name: item.commonreason,
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else if (item.status === 2 && item.sellerpullstate === 2) {
								this.orderfollowArr.unshift({
									name: '订单被驳回',
									reason: '',
									time: item.modifydate,
									username: item.username
								})
							} else {
								if (this.needauditingflag) {
									this.orderfollowArr.unshift({
										name: this.orderType1[item.status].name,
										reason: '',
										time: item.modifydate,
										username: item.username
									})
								} else {
									this.orderfollowArr.unshift({
										name: this.orderType0[item.status].name,
										reason: '',
										time: item.modifydate,
										username: item.username
									})
								}
							}
						}
					})
					this.orderfollowArr.forEach((item, index) => {
						if (index === 0) {
							item.color = this.$fxPrimaryColor
						}
					})
				}
			})
		},
		dialogShow () {
			this.dialogVisible = true
		},
		deliveryClick () {
			if (this.code === '') {
				this.$message.error('请输入物流单号')
				return false
			}
			let express = {
				companycode: this.value,
				id: this.expressId,
				number: this.code
			}
			let params = {
				orderid: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId,
				express: express
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update/express`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('物流信息保存成功！')
					this.expressId = res.data
					this.deliveryCode = this.code
					this.options.forEach(item => {
						if (item.id === this.value) {
							this.deliveryCompany = item.value
						}
					})
					this.dialogVisible = false
				} else {
					this.$message.error(res.msg)
				}
			}).catch((err) => {
				this.$message.error(err.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.delivery-body {
	width: 280px
	padding: 18px 29px 25px 15px
	font-size: 14px
	padding :10px;
	background-color:#F8FCFF;
	border :1px solid #DCE2FD;
	border-radius :4px;
	overflow-y:auto;
	.fx-title {
		font-weight: 700
		margin: 0 0 18px 0
	}
	.delivery-info {
		padding: 0 12px 0 12px
		text-align: left
		border-bottom 1px solid #DCE2FD
		p {
			margin-bottom: 15px
		}
		.empty-info {
			display: flex;
			flex-flow: column;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #999999;
			img {
				width: 35px;
				height: 32px;
			}
		}
	}
	.dialog-body {
		p {
			margin-bottom: 10px
		}
		.delivery-input {
			width: 100%
			margin-bottom: 10px
			&:last-child {
				margin-top: 20px
			}
		}
	}
	.flow-order {
		padding-top: 22px
	}
	.block {
		text-align: left
		h5, .timeline {
			font-size: 14px;
			font-weight: 400;
			display: flex;
			flex-flow: column
			align-items: start
			color: #333333;
			p {
				padding-left: 15px
			}
		}
		.operator {
			color: #999999
			padding-top: 20px;
		}
	}
}
</style>
<style lang="stylus">
.delivery-body {

	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-timeline-item__node--normal {
		width: 8px;
    height: 8px;
	}
	.el-timeline-item__tail {
		position: absolute
		left: 2px
	}
	.el-timeline-item__wrapper {
		position: relative
    padding-left: 12px
		top: -18px;
	}
}
</style>
